import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import {Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl} from '@material-ui/core'
import {Container, Box} from '@material-ui/core'
import {Button, TextField } from '@material-ui/core';
import { t } from 'i18next';
import { isInteger, isNumber } from '../../../api/validators';
import { base64toGuid, base64ToUint8Array, guidToBase64, uint8ArrayToBase64 } from '../../../api/helpers';


class ServerLinkDialog_ extends React.Component{

    constructor(props){
        super(props)

        //const {settings} = this.props
        console.log('ServerLinkDialog constuctor')
        console.log('this.props.serverLink')
        console.log(this.props.serverLink)

        let guid = this.props.serverLink.ID ? base64toGuid(this.props.serverLink.ID) : ''
        let id = guidToBase64(guid)
        console.log("SERVER GUID "+ guid + ' => ' + id)


        this.state = {
            serverLink: this.props.serverLink,

            guid: this.props.serverLink.ID ? base64toGuid(this.props.serverLink.ID) : '',
            
            errors:{
                ID: false,
                ExternalName: false, 
                IPEndpoint: false,
                //guid: false,
                ExternalLogin: false,
                ExternalPassword: false,
                LocalLogin: false
            },
            //permissionsDialogOpen: false,
            changed: false,
            //permissionsType: user.ID && user.Permissions>=0 ? 0 : -1
        }

        this.handleInput = this.handleInput.bind(this)
        this.handleGuidInput = this.handleGuidInput.bind(this)

        this.handleSave = this.handleSave.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleComplete = this.handleComplete.bind(this)
    }

    handleSave(){
        if(this.checkForm()){
            let serverLink = {...this.props.serverLink, ...this.state.serverLink}

            this.props.onAction({
                type: 'SERVER_LINK_SAVE', 
                serverLink: serverLink, 
                opType: this.props.opType,
                callback: this.handleComplete})
            
        }else{
            this.props.onAction({type:'ALERT_DIALOG', message: this.props.t('CheckFormForErrors')})
        }
    }

    handleComplete(){
        this.props.onAction({type: 'SERVER_LINK_DIALOG_CLOSE'})
        return true
    }

    handleClose(){
        if(this.state.changed){
            this.props.onAction({
                type: 'CONFIRM_DIALOG', 
                message: this.props.t('CloseFormConfirm'),
                onConfirm: ()=>{
                    this.props.onAction({type: 'SERVER_LINK_DIALOG_CLOSE'})
                }
            })
        }else{
            this.props.onAction({type: 'SERVER_LINK_DIALOG_CLOSE'})
        }
    }

    handleInput(event){
        let changed = !this.state.changed ? {changed: true} : {}
        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value
        
        const serverLink = {...this.state.serverLink, [event.target.name]: val}
        
        let err = this.validate(event.target.name, val)
        const errors = {errors: {...this.state.errors, [event.target.name]: err}}

        this.setState({serverLink: serverLink, ...changed,  ...errors})
    }

    handleGuidInput(event){
        let changed = !this.state.changed ? {changed: true} : {}
        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value

        let err = this.validate(event.target.name, val)
        const errors = {errors: {...this.state.errors, [event.target.name]: err}}

        this.setState({guid: val, ...changed,  ...errors})
    }

    validate(name, value){
        const {t} = this.props

        let error = false

        //console.log('validate '+ name + ' = '+value)
        /* ID: false,
                ExternalName: false, 
                guid: false,
                ExternalLogin: false,
                ExternalPassword: false,
                LocalLogin: false
                */

        switch(name){
            case 'ExternalName':
            case 'ExternalLogin':
            case 'ExternalPassword':
            case 'LocalLogin':
            case 'IPEndpoint':
                if(!value) return this.label(name) + ': ' + t('ValueIsEmpty')
                break

            case 'ID':{

                //var pattern = new RegExp('^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$', 'i');

                var pattern = new RegExp('^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$', 'i');

                if (pattern.test(value) === true) {
                    
                    var id = guidToBase64(value)
                    if(id){
                        const serverLink = {...this.state.serverLink, ID: id}
                        this.setState({serverLink: serverLink})
                    }

                }else{
                    return t('WrongGuidString')
                }

                break
            }

        }

        return error
    }

    label(name){
        let {t} = this.props
        switch(name){
            default: return t(name)
        }
    }

    checkForm(){
        console.log('checkform')
        console.log(this.state.dispatcher)
        let check = true
        let errors = {...this.state.errors}
        for(var i in errors){
            let v = null
            let error = false
            v = this.state.serverLink[i]
   
            if(i==='ID'){
                v = this.state.guid 
            }
            error = this.validate(i, v)
            errors[i] = error
            if(error) {
                console.error({field: i, value: v, error: error})
                check = false
            }
        }
        this.setState({errors: errors})
        return check
    }


    render(){

        const {t} = this.props

        const margin = {margin:'16px 0 8px 0'}

        return (
        
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose}
    aria-labelledby="edit-dialog-title">
        
    <DialogTitle id="edit-dialog-title">{t('ExternalServer')}</DialogTitle>
    <DialogContent>
        <form>
        <Container maxWidth="lg" style={{minWidth:400}}>

            <Box textAlign="left" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.serverLink.LinkState?true:false}
                            onChange={this.handleInput}
                            name="LinkState"
                            />
                            {t('Active')}
                    </label>
                </FormControl>
            </Box>

            <Box textAlign="center">
                <TextField name="ExternalName"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.ExternalName?this.state.errors.ExternalName:t('Name')}
                    autoComplete="new-password"
                    error={this.state.errors.ExternalName!==false}
                    value={this.state.serverLink.ExternalName}
                    onChange={this.handleInput}
                />
            </Box>

            <Box textAlign="center">
                <TextField name="ID"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.ID?this.state.errors.ID:t('ExternalServerIdentity')}
                    autoComplete="new-password"
                    error={this.state.errors.ID!==false}
                    value={this.state.guid}
                    disabled={this.props.opType!==1?true:false}
                    onChange={this.handleGuidInput}
                />
            </Box>

            <Box textAlign="center">
                <TextField name="IPEndpoint"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.ExternalLogin?this.state.errors.ExternalLogin:t('IPEndpoint')}
                    autoComplete="new-password"
                    error={this.state.errors.IPEndpoint!==false}
                    value={this.state.serverLink.IPEndpoint}
                    onChange={this.handleInput}
                />
            </Box>

            <Box textAlign="center">
                <TextField name="ExternalLogin"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.ExternalLogin?this.state.errors.ExternalLogin:t('ExternalLogin')}
                    autoComplete="new-password"
                    error={this.state.errors.ExternalLogin!==false}
                    value={this.state.serverLink.ExternalLogin}
                    onChange={this.handleInput}
                />
            </Box>

            <Box textAlign="center">
                    <TextField type="password" name="ExternalPassword" margin="normal"
                        style={{width: '100%'}}
                        label={this.state.errors.ExternalPassword?this.state.errors.ExternalPassword:t('ExternalPassword')}
                        autoComplete="new-password"
                        error={this.state.errors.ExternalPassword!==false}
                        value={this.state.serverLink.ExternalPassword}
                        onChange={this.handleInput}
                    />
                </Box>

            <Box textAlign="center">
                <TextField name="LocalLogin"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.LocalLogin?this.state.errors.LocalLogin:t('LocalLogin')}
                    autoComplete="new-password"
                    error={this.state.errors.LocalLogin!==false}
                    value={this.state.serverLink.LocalLogin}
                    onChange={this.handleInput}
                />
            </Box>
        
            </Container>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSave} variant="contained" color="primary">
            {t('Apply')}
        </Button>
        <Button onClick={this.handleClose} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>        
        
        
        )

    }


}

export const ServerLinkDialog = withTranslation()(ServerLinkDialog_);